import { useContext } from "react";
import { OrgContext } from "src/contexts";

const useHasFeature = (name: string) => {
  const { org } = useContext(OrgContext);
  return org?.features?.find((f) => f.name === name);
};

export default useHasFeature;
